import React from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from 'axios';
import { host } from '../../../config';
import {
  FormGroup,
  Button,
  ButtonToolbar,
  HelpBlock,
  Modal,
} from 'react-bootstrap';
import { Form, Field } from 'react-final-form';
import TextEditor from "./TextEditor";
import { any } from "bluebird";
import AddcityNotesModal from "./AddcityNotesModal";
import { displayBidderBidState, displayBuyerBidState } from "../../../core/api";
import EditgridTableModal from "./EditgridTableModal";
import UploadFormModal from "./UploadFormModal ";

class Definebidgrid extends React.Component {
  constructor(props) {
    super(props);
    let newBiddata = [{
      id: [],
      roomType: "Choose Room Types",
      numberOfRooms: '',
      numberOfNights: '',
      date_in: '',
      date_out: ''
    }];

    let bidIDS = []


    // Remove the first empty entry if member_data exists and has data
    if (newBiddata && newBiddata.length > 0) {
      newBiddata.shift();
    }
    this.state = {
      toolbar,
      gridData: false,
      chkBoxVal: 1,
      chkBoxvalking: 1,
      chkBoxvaldouble: 1,
      showWarning: false,
      modalText: '',
      viewMap: false,
      showAddHotel: false,
      showHotelDetail: false,
      showHotelDefineBid: false,
      showmodal: false,
      showConfirm: false,
      showSetCheckInOutDate: false,
      showSetRoomTypes: false,
      roomTypeData: {},
      isApplyDisabled: false,
      location: null,
      additionalQuestion: [],
      disabled: false,
      inputVal: false,
      question: null,
      countClick: 0,
      noOfQuestion: 0,
      btndis: true,
      showChangeDate: false,
      newBiddata,
      bidIDS,
      isLoading: true,
      confirmPopUP: null,
      CheckBidTableSave: false,
      bidStatus: [],
      editpopup: false,
      editConfirmation: false,
      typeEdit: false,
      newTypeEdit:false,
      group_id: this.props.event.group,
      selectedGroupTabs: [],
      tempGroupIdStored: [],
      showSpinner: true,
      cityNotesPopUp: false,
      cityNotesData: [],
      hideSaveButton: false,
      editTablePopup: false,
      bidid: [],
      uploadDocModel:false
    };
    this.handleCityNotesSubmit = this.handleCityNotesSubmit.bind(this);
    this.onHideCityNotes = this.onHideCityNotes(this);
    this.handleCellEdit = this.handleCellEdit.bind(this)
  }
  componentWillMount() {
    const { city_notes, city_id } = this.props
    const { cityNotesData } = this.state;
    const cityData = city_notes.filter(item => item.city_id === city_id)
    this.setState({
      cityNotesData: cityData,
      bidStatus: [],
      event_id:this.props.event.id
    })
    this.fetchData()
  }
  componentWillReceiveProps(prevProps) {

  }

  componentDidUpdate(prevProps) {
    if (this.props.group_id !== prevProps.group_id) {
      this.setState({
        showSpinner: true,
        bidStatus: [],
      });

      this.fetchData();
    }
  }

  fetchData = () => {
    const { group_id, event_id, selectedTourId } = this.props;
    this.setState({ isLoading: true });

    Promise.all([
      // this.fetchBidData(selectedTourId),
      this.fetchBidValue(group_id, event_id),
      // this.props.requestBidsets(selectedTourId)
    ])
      .then(([bidValueResponse]) => {
        // this.processBidData(bidResponse.data.results);
        this.showBidData(bidValueResponse.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        this.setState({ isLoading: false, showSpinner: false });
      });
  };


  fetchBidData = (tour_id) => {
    const tokenKey = JSON.parse(sessionStorage.getItem('auth')).token;
    return axios.get(`${host}/api/bid/?tour_id=${tour_id}`, {
      headers: {
        Authorization: `Token ${tokenKey}`,
      },
    });
  }

  fetchBidValue = (group_id, event_id) => {
    const tokenKey = JSON.parse(sessionStorage.getItem('auth')).token;
    return axios.get(`${host}/api/bidvalue/get_bid_value/?group_id=${group_id}&event_id=${event_id}`, {
      headers: {
        Authorization: `Token ${tokenKey}`,
      },
    });
  }

  sendMailHotel(bidStatus) {
    const tokenKey = JSON.parse(sessionStorage.getItem('auth')).token;
    const uploadUrl = `${host}/api/bidvalue/send_edit_message/`;
    return axios.post(uploadUrl, bidStatus, {
      headers: {
        Authorization: `Token ${tokenKey}`,
      },
    })
      .then(() => {

      })
      .catch((error) => {
        console.error('Error uploading document:', error);
      });
  }
  displayBidState(buyerState, bidderState) {
    if (['ST'].includes(buyerState)) {
      return displayBuyerBidState(buyerState, bidderState);
      // `${displayBuyerBidState(buyerState, bidderState)} (${displayBidderBidState(
      //   buyerState,
      //   bidderState
      // )})`;
    }
    return displayBuyerBidState(buyerState, bidderState);
  }

  processBidData = (bids) => {
    const eventPlaceName = this.props.event.place.city
    const eventGroupName = this.props.event.group_name
    const bidStatus = [];
    const bidid=[];

    bids.forEach((bid) => {
      let displayState = this.displayBidState(bid.buyer_state, bid.bidder_state);
      if(bid.tourgroup_id === this.props.group_id){
        bidid.push({
          bidId: bid.id,
          displayState: displayState
        })
      }
      try {
        const hotel_mail = bid.bidder.email
        const agent_name = bid.bidder.username
        const bidGroupName = bid.bidset.event.group_name
        const bidPlaceName = bid.bidset.event.place.city
        const bidUrl = bid.bid_url
        if ((displayState === 'Responded' || displayState === 'Accept') && bidGroupName === eventGroupName && bidPlaceName === eventPlaceName) {
          bidStatus.push({
            displayState: displayState,
            hotel_mail: hotel_mail,
            agent_name: agent_name,
            bid_url: bidUrl
          })
        }
      } catch (error) {
        console.error('Error rendering document content:', error);
      }
    });
    this.setState({
      bidStatus: bidStatus,
      bidid:bidid
    })
  }
  
  // showBidData(bid_details) {
  //   this.setState({
  //     newBiddata: []
  //   })
  //   const { event_id } = this.props

  //   for (let i = 0; i < bid_details.length; i++) {
  //     this.state.bidIDS.push(
  //       {
  //         id: bid_details[i].id,
  //         king: bid_details[i].king,
  //         suite: bid_details[i].suite,
  //         double: bid_details[i].double,
  //         twobeds: bid_details[i].twobeds,
  //         Juniorsuite: bid_details[i].Juniorsuite,
  //         twobedroomsuite: bid_details[i].twobedroomsuite,
  //         in_date: bid_details[i].check_in_date,
  //         out_date: bid_details[i].check_out_date
  //       }
  //     )
  //   }
  //   if (bid_details && bid_details.length > 0) {
  //     let roomCounter = 0;
  //     let processedRoomTypes = new Set(); // To avoid storing duplicate room types 
  //     for (let i = 0; i < bid_details.length;) {
  //       const currentPayload = bid_details[i];
  //       const roomType = currentPayload.suite ? 'Suite' : currentPayload.king ? 'King' : currentPayload.double ? 'Double' : currentPayload.twobeds ? 'Two Beds' : currentPayload.Juniorsuite ? 'Junior Suite' : '2 Bedroom Suite';
  //       let uniqueKey = `${roomType}-${bid_details[i].check_in_date}-${bid_details[i].check_out_date}`;
  //       if (!processedRoomTypes.has(uniqueKey)) {
  //         let numberOfRooms = 0;
  //         let dateIn = '';
  //         let dateOut = '';
  //         let storeId = []

  //         for (let j = i; j < bid_details.length; j++) {
  //           if (bid_details[j].suite === currentPayload.suite && bid_details[j].king === currentPayload.king && bid_details[j].double === currentPayload.double && bid_details[j].twobeds === currentPayload.twobeds && bid_details[j].Juniorsuite === currentPayload.Juniorsuite && bid_details[j].twobedroomsuite === currentPayload.twobedroomsuite && bid_details[j].check_in_date === currentPayload.check_in_date && bid_details[j].check_out_date === currentPayload.check_out_date) {
  //             storeId.push(bid_details[j].id)
  //             numberOfRooms++;
  //             dateIn = bid_details[j].check_in_date ? bid_details[j].check_in_date : this.props.currentEventDate;
  //             dateOut = bid_details[j].check_out_date;
  //             processedRoomTypes.add(uniqueKey);
  //           }
  //         }
  //         let numberOfNights = ''
  //         if (dateIn && dateOut) {
  //           const diffInTime = new Date(dateOut).getTime() - new Date(dateIn).getTime();
  //           const diffInDays = diffInTime / (1000 * 3600 * 24);
  //           numberOfNights = diffInDays.toString();
  //         }
  //         // const diffInTime = new Date(dateOut).getTime() - new Date(dateIn).getTime();
  //         // const diffInDays = diffInTime / (1000 * 3600 * 24);
  //         // let numberOfNights = diffInDays.toString();
  //         this.state.newBiddata.push({
  //           id: storeId,
  //           roomType: roomType,
  //           numberOfRooms: numberOfRooms,
  //           date_in: dateIn,
  //           date_out: dateOut,
  //           numberOfNights: numberOfNights,
  //         });

  //         roomCounter++;
  //       } else {
  //         i++;
  //       }
  //     }
  //   }
  //   this.setState({
  //     isLoading: false
  //   })
  // }

  showBidData = (bid_details) => {
    const uniqueRooms = new Map();

    for (const bid of bid_details) {
      const roomType = bid.suite ? 'Suite' : bid.king ? 'King' : bid.double ? 'Double' : bid.twobeds ? 'Two Beds' : bid.Juniorsuite ? 'Junior Suite' : '2 Bedroom Suite';
      const key = `${roomType}-${bid.check_in_date}-${bid.check_out_date}`;

      if (!uniqueRooms.has(key)) {
        uniqueRooms.set(key, {
          id: [bid.id],
          roomType,
          numberOfRooms: 1,
          date_in: bid.check_in_date || this.props.currentEventDate,
          date_out: bid.check_out_date,
          numberOfNights: this.calculateNumberOfNights(bid.check_in_date, bid.check_out_date),
        });
      } else {
        const room = uniqueRooms.get(key);
        room.id.push(bid.id);
        room.numberOfRooms++;
      }
    }

    const newBiddata = Array.from(uniqueRooms.values());
    this.setState({ newBiddata, isLoading: false });
  };

  calculateNumberOfNights = (checkInDate, checkOutDate) => {
    const diffInTime = new Date(checkOutDate).getTime() - new Date(checkInDate).getTime();
    return (diffInTime / (1000 * 3600 * 24)).toString();
  };

  onCloseWarning = () => {
    this.setState({
      showWarning: false,
    });
  }
  onCloseConfirm = () => {
    this.setState({
      showConfirm: false,
    });
  }
  onHideEditPop = () => {
    this.setState({
      editpopup: false
    })
  }
  addBidIds = () => {
    const eventPlaceName = this.props.event.place.city;
    const eventGroupName = this.props.event.group_name;
    const bidStatus = [];
    const bididAll = [];
    const bididNotWithSent = [];
    let confirmMessage=false;
    let stayUpdateMessage = false;
    let ResPoseAcceptType=true;

    this.props.bidsvalue.forEach((bid) => {
        let displayState = this.displayBidState(bid.buyer_state, bid.bidder_state);
        const bidGroupName = bid.bidset.event.group_name;
        const bidPlaceName = bid.bidset.event.place.city;

        if (bid.tourgroup_id === this.props.group_id &&
            bid.bidset.event.id === this.props.event_id &&
            bidGroupName === eventGroupName &&
            bidPlaceName === eventPlaceName) {
            if(displayState === 'Responded' || displayState === 'Accept'){
              ResPoseAcceptType=false
              bididAll.push({
                bidId: bid.id,
                displayState: displayState
            });
            }
            else if (displayState === 'Stay Updated') {
                confirmMessage = true
                stayUpdateMessage = true;
                bididNotWithSent.push({
                    bidId: bid.id,
                    displayState: displayState
                });
            } else {
              confirmMessage = true
                bididAll.push({
                    bidId: bid.id,
                    displayState: displayState
                });
            }
        }

        try {
            if ((displayState === 'Responded' || displayState === 'Accept') &&
                bidGroupName === eventGroupName &&
                bidPlaceName === eventPlaceName) {
                const hotel_mail = bid.bidder ? bid.bidder.email : null;
                const agent_name = bid.bidder ? bid.bidder.username : null;
                const bidUrl = bid.bid_url;
                bidStatus.push({
                    displayState: displayState,
                    hotel_mail: hotel_mail,
                    agent_name: agent_name,
                    bid_url: bidUrl
                });
            }
        } catch (error) {
            console.error('Error rendering document content:', error);
        }
    });
    if (ResPoseAcceptType) {
      if(confirmMessage){
        const message = stayUpdateMessage ?
            'Some hotels have stay updating. Do you want to update that?' :
            'Do you want to update the hotel status to Stay Updated?  Clicking OK will allow you to resend the new information to the hotels you have bids with in the Requests Bids or Manage Bids section.  Clicking Cancel will change the dates but will not notify the hotels.';
        const confirmPopup = window.confirm(message);
        if(!stayUpdateMessage){
          this.setState({
            bidStatus: bidStatus,
            bidid: bididAll.concat(bididNotWithSent),
            typeEdit:!confirmPopup
        }, () => {
            this.onSubmit();
        });
        }
        else{
          this.setState({
            bidStatus: bidStatus,
            bidid: bididAll.concat(bididNotWithSent),
            typeEdit:confirmPopup
        }, () => {
            this.onSubmit();
        });
        }
      }
      else{
        this.setState({
          bidStatus: bidStatus,
          bidid: bididAll,
          typeEdit: true
      }, () => {
          this.onSubmit();
      });
      }
        
    } else {
        this.setState({
            bidStatus: bidStatus,
            bidid: bididAll,
            typeEdit: true
        }, () => {
            this.onSubmit();
        });
    }
};

  

  onSubmit = () => {
    //debugger;
    let payloaddummy = [];
    const { event_id } = this.props
    let counter = 0
    const { typeEdit,newTypeEdit } = this.state
    let roomCounter = 0;
    for (let i = 0; i < this.state.newBiddata.length; i++) {
      const formData = this.state.newBiddata[i];
      if (formData.roomType === 'Choose Room Types' || formData.numberOfRooms === '' ) {
        continue
      }
      const totalRoomsForFormData = formData.numberOfRooms;
      const bid_ids = formData.id;
      const roomType = formData.roomType === 'Suite' ? 'Suite' : formData.roomType === 'King' ? 'King' : formData.roomType === 'Double' ? 'Double' : formData.roomType==='Two Beds'?'Two Beds':formData.roomType==='Junior Suite'?'Junior Suite':formData.roomType==='2 Bedroom Suite'?'2 Bedroom Suite':'';
      for (let j = 0; j < totalRoomsForFormData; j++) {
        let idToPush = 0; // Initialize with 0
        if (bid_ids && bid_ids.length > j) {
          idToPush = bid_ids[j];
        } else {
          idToPush = 0;
        }

        payloaddummy.push({
          suite: formData.roomType === 'Suite',
          king: formData.roomType === 'King',
          double: formData.roomType === 'Double',
          twobeds: formData.roomType === 'Two Beds',
          Juniorsuite: formData.roomType === 'Junior Suite',
          twobedroomsuite: formData.roomType === '2 Bedroom Suite',
          check_in_date: formData.date_in,
          check_out_date: formData.date_out,
          travelprofile_id: 0,
          tour_id: this.props.selectedTourId,
          group_id: this.props.event.group,
          bid_id: this.props.selectedTour.bid_id,
          event_id: event_id,
          room_type: formData.roomType === 'Suite' ? 1 : formData.roomType === 'King' ? 2 : formData.roomType === 'Double' ? 3 : formData.roomType === 'Two Beds' ? 4 : formData.roomType === 'Junior Suite' ? 5 : formData.roomType === '2 Bedroom Suite' ? 6 : 0,// Adjust the logic for room types as per your requirements
          id: idToPush,
          editType: typeEdit,
          newTypeEdit:newTypeEdit,
          bidId:this.state.bidid
        });
        // console.table(payloaddummy)

        roomCounter++;
        counter++;
      }
    }
    this.setState({
      CheckBidTableSave: true
    })
    if (payloaddummy.length > 0) {
      this.setState({ showSpinner: true })
      this.props.addMultipleBidDetail(payloaddummy, true, (response) => {
       // Call fetchData after addMultipleBidDetail completes
        this.fetchData();
      })
      this.setState({
        hideSaveButton: true
      })
    } else {
      this.props.onClose();
    }
  }
  
  handleCellEdit = (row, fieldName, value) => {
    this.setState((prevState) => {
        let updatedRows;
        let index;

        if (prevState.newBiddata.length === 0) {
            // If newBiddata is empty, handle the empty case
            updatedRows = [{ ...row, [fieldName]: value }];
            index = 0;
        } else {
            // If newBiddata has data, find the index as before
            index = prevState.newBiddata.findIndex((item) =>
                Object.keys(row).every((key) => item[key] === row[key])
            );
            updatedRows = [...prevState.newBiddata];
            updatedRows[index][fieldName] = value;
        }

        // Check if check-in date is greater than or equal to the current date
        const { date_in } = updatedRows[index];
        const currentDate = new Date();

        // Check if check-in date is greater than or equal to tourData[0].start
        const tourStartDate = new Date(this.props.currentEventDate);

        const { date_out, numberOfRooms } = updatedRows[index];

        if (numberOfRooms === '') {
            // If numberOfRooms is empty, remove the row from the array
            updatedRows.splice(index, 1);
        } else if (date_in && date_out) {
            const checkInDate = new Date(date_in);
            const checkOutDate = new Date(date_out);

            // Check if check-in date is later than check-out date
            if (checkInDate > checkOutDate) {
                alert('Check-out date cannot be less than Check-in date');
                updatedRows[index].date_out = null; // Reset date_out to null
                updatedRows[index].numberOfNights = null;
            } else {
                const diffInTime = checkOutDate.getTime() - checkInDate.getTime();
                const diffInDays = diffInTime / (1000 * 3600 * 24);
                updatedRows[index].numberOfNights = diffInDays.toString();
            }
        }
        return { newBiddata: updatedRows };
    });
};

    updatedNewRows(value) {
    this.setState({
      newBiddata: value
    })
  }


  handleAddRow = () => {
    const { newBiddata } = this.state;
    const currentEvent = this.props.currentEventDate
    const emptyRow = {
      roomType: 'Choose Room Types',
      id: 0,
      numberOfRooms: 0,
      date_in: currentEvent,
      date_out: '',
      numberOfNights: ''
      // Add other fields as needed
    };

    // Add the new empty row to the state
    this.setState({
      newBiddata: [...newBiddata, emptyRow],
    });
  };

  addCityNotes() {
    this.setState({
      cityNotesPopUp: true,
    })

  }
  onHideCityNotes = () => {
    this.setState({
      cityNotesPopUp: false,
    })
  }
  handleCityNotesSubmit(values) {
    const { city_id, city_details } = this.props
    const cityDetails = city_details.filter(item => item.id === city_id)
    const cityname = cityDetails[0].name;
    const firstCityName = cityname.split(',')[0].trim();
    const payload = []

    payload.push({
      tour_id: this.props.selectedTourId,
      city_name: firstCityName,
      city_id: city_id,
      values: values.note_json
    })
    this.props.saveCityNotes(payload) // api for send city notes
    this.props.DeleteEventNotes(city_id)
    this.setState({
      cityNotesPopUp: false,
    })
  }

  showBidStatus = () => {
    const { bidsvalue } = this.props
    if (bidsvalue.length > 0) {
      const eventPlaceName = this.props.event.place.city
      const eventGroupName = this.props.event.group_name
      const bidStatus = [];
      const bidid = [];

      bidsvalue.forEach((bid) => {
        try {
          const displayState = this.displayBidState(bid.buyer_state, bid.bidder_state);
          const hotel_mail = bid.bidder?bid.bidder.email:null
          const agent_name = bid.bidder?bid.bidder.username:null
          const bidGroupName = bid.bidset.event.group_name
          const bidPlaceName = bid.bidset.event.place.city
          const bidUrl = bid.bid_url
          if ((displayState === 'Responded' || displayState === 'Accept') && bidGroupName === eventGroupName && bidPlaceName === eventPlaceName) {
            bidStatus.push({
              displayState: displayState,
              hotel_mail: hotel_mail,
              agent_name: agent_name,
              bid_url: bidUrl
            })
          }
        } catch (error) {
          console.error('Error rendering document content:', error);
        }
      });
      this.setState({
        bidStatus: bidStatus,
      })
    }
    this.setState({
      editTablePopup: true,
      typeEdit: true,
    })
  }
  openUploadDocument=()=>{
    this.setState({ uploadDocModel:true })
  }

  closeModal=()=>{
    this.setState({ uploadDocModel:false })
  }

  render() {
    const selectRoomTypeOptions = ['Suite', 'King', 'Double', 'Two Beds', 'Junior Suite', '2 Bedroom Suite'];
    const { showSpinner, cityNotesData, hideSaveButton, newBiddata } = this.state;
    const { group_id, event_id, bidsvalue} = this.props
    if (showSpinner) {
      return (
        <div className="spinner" style={{ display: 'flex', justifyContent: 'center' }} >
          <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      );
    }
    return (
      <div>
        <div>
          <Form
            onSubmit={this.addBidIds}
            render={({ handleSubmit, pristine, invalid }) => (
              <form onSubmit={handleSubmit}>
                <div className="container-fluid">
                  <div className="row">
                    <div>
                      <BootstrapTable
                        data={newBiddata}
                        striped
                        cellEdit={{
                          mode: 'click',
                          blurToSave: true,
                          afterSaveCell: this.handleCellEdit,
                        }}
                      >
                        <TableHeaderColumn hidden isKey dataField="id" width="100">
                          ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="roomType" width="150" headerAlign="center" dataAlign="center"
                          editable={{
                            type: 'select',
                            options: { values: selectRoomTypeOptions },
                            validator: (value) => value !== ''
                          }}
                        >
                          Room Type
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="numberOfRooms" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}> No of rooms</TableHeaderColumn>
                        <TableHeaderColumn dataField="date_in" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date in &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
                        <TableHeaderColumn dataField="date_out" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date out &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
                        <TableHeaderColumn dataField="numberOfNights" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}> No of nights</TableHeaderColumn>
                      </BootstrapTable>
                    </div>
                    {/*<Button bsStyle="danger btn-sm" style={{ margin: "12px 12px", width: '10%', float: 'right' }} onClick={this.handleRemoveEmptyRows}>Remove</Button>*/}
                  </div>
                  <div className="row">
                    <div className="col-md-12 left-padding-zero">
                        <p style={{color:'green',marginBottom:'0px',marginTop:'5px'}} >
                            Click to add documents to each hotel bid in this city.
                        </p>
                      <FormGroup style={{ marginBottom: '3px'}} >
                        <ButtonToolbar>
                          {this.props.bidsvalue.filter((value) => (
                            value.tourgroup_id === group_id && value.bidset.event.id === event_id && (value.buyer_state === 'AC' || value.buyer_state === 'PD')
                          )).length > 0 ? (
                            <div>
                              <Button bsStyle="info" onClick={this.showBidStatus} style={{ margin: "12px 12px", width: '18%', float: 'right' }}>
                                Edit Bid
                              </Button>
                            </div>
                          ) : (
                            <div>
                              <Button bsStyle="success" style={{ margin: "12px 12px", width: '18%', float: 'right' }} onClick={this.handleAddRow}>
                                Add Rooms
                              </Button>
                              <Button bsStyle="success" type="submit" style={{ margin: "12px 12px", width: '10%', float: 'right' }}>
                                Save
                              </Button>
                            </div>
                          )}

                          <Button bsStyle="success" style={{ margin: "12px 12px", width: '25%', float: 'left' }} onClick={() => this.addCityNotes()}>
                            Add City Note
                          </Button>
                          <div style={{marginTop:'9px'}} >
                            <Button bsStyle="success formbtn" bsSize="small" onClick={this.openUploadDocument} > 
                                <i className="fa fa-file-code-o" /> Manage Bid Documents
                            </Button>
                          </div>
                        </ButtonToolbar>
                      </FormGroup>
                      <div>
                        <p style={{color:'green'}} >
                          To remove a line, please make the number of rooms zero and save.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            )}
          />
        </div>
        <div>
          {this.state.cityNotesPopUp && (
            <AddcityNotesModal
              {...this.props}
              cityNotesPopUp={this.state.cityNotesPopUp}
              onClose={() => {
                this.setState({
                  cityNotesPopUp: false,
                })
              }}
              saveCityNotes={this.props.saveCityNotes}
              DeleteEventNotes={this.props.DeleteEventNotes}
            />
          )}
        </div>
        <div>
          {this.state.uploadDocModel && (
            <UploadFormModal
            event_id={this.props.city_id}
            tour={this.props.selectedTour.tour}
            model_type={'Hotel Docs'}
            upload_type={'Tour Group'}
            show={this.state.uploadDocModel}
            onClose={this.closeModal} />
          )}
        </div>
        <div>
          {this.state.editTablePopup && (
            <EditgridTableModal
              {...this.props}
              // updateGridValue={(values) => this.updatedNewRows(values)}
              handleCellEdit={this.handleCellEdit}
              addRooms={() => this.handleAddRow()}
              currentEventDate={this.props.currentEventDate}
              typeEdit={this.state.typeEdit}
              bidStatus={this.state.bidStatus}
              gridvalue={this.state.newBiddata}
              bidid={this.state.bidid}
              show={this.state.editTablePopup}
              fetchData ={()=>this.fetchData()}
              onSubmit = {()=>this.addBidIds()}
              onClose={() => {
                this.setState({
                  editTablePopup: false,
                })
              }}
            />
          )}
        </div>
      </div>
    )
  }
}

export default Definebidgrid


// WEBPACK FOOTER //
// src/routes/tours/components/Definebidgrid.js